import LocationSvg from "assets/icons/svg/localtion";
import React, { useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import "./index.scss";
import { Fonts } from "theme/fontConfig";

const DropdownIndicator = (props) => {
  return (
    <div className="px-2">
      <LocationSvg label="Emoji" />
    </div>
  );
};

const FindMyCity = ({
  rowTitle,
  title,
  value,
  handleChange,
  saveNewAddress,
  isDisabled = false,
}) => {
  const country = JSON.parse(
    localStorage.getItem("country") !== "undefined"
      ? localStorage.getItem("country")
      : "{}"
  );
  const countryCode = useMemo(() => {
    return country?.code || "us";
  }, [country]);

  const [inputText, setInputText] = useState(value?.label || "");
  const justSelectedRef = React.useRef(false);

  return (
    <div className="map-title">
      <div style={{ fontSize: Fonts.GeneralBodyFont.fontSize, marginBottom: "10px" }}>{title}</div>
      <div>
        <Row>
          {rowTitle && (
            <Col xs={4}>
              <div className="container-title">{rowTitle}</div>
            </Col>
          )}
          <Col>
            <GooglePlacesAutocomplete
              className="d-flex form-control form-control-solid px-6 pt-8 pb-9 align-items-center"
              apiKey={"AIzaSyCAt0TjvU_m8ufUMYn2EXi9mteHSOUB7uA"}
              selectProps={{
                value,
                onChange: (val) => {
                  justSelectedRef.current = true;
                  setTimeout(() => { justSelectedRef.current = false; }, 500);
                  handleChange(val);
                },
                isDisabled: isDisabled,
                onInputChange: (newValue) => setInputText(newValue),
                onBlur: saveNewAddress
                  ? () => {
                      if (justSelectedRef.current) return;
                      if (
                        inputText?.trim()?.length &&
                        inputText !== value?.label
                      ) {
                        handleChange({
                          label: inputText,
                          value: { place_id: null },
                        });
                      }
                    }
                  : null,
                components: {
                  DropdownIndicator,
                  IndicatorSeparator: () => null,
                },
                ...(isDisabled && {
                  styles: {
                    control: (base, state) => ({
                      ...base,
                      minHeight: 47,
                      border: "none",
                    }),
                  },
                }),
              }}
              autocompletionRequest={{
                componentRestrictions: {
                  country: [countryCode?.toLowerCase()],
                },
              }}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default FindMyCity;
